// Module
var code = `<div style="padding: 10px; margin: 10px 0; border-radius: 5px">
  <div
    style="display: flex; flex-direction: row; flex-wrap: nowrap; align-items: center; justify-content: space-between"
  >
    <span style="margin: auto" data-bind="label: 'cc_P_LOADING'"></span>
  </div>
  <div class="text-center" style="margin: 20px 0">
    <i class="fa fa-spinner fa-spin" style="font-size: 36px"></i>
  </div>
</div>
`;
// Exports
module.exports = code;